<template>
    <div class="user-summary">
        <img class="user-summary--border" src="@/assets/images/decoration/flowers.svg" alt="Flowers Image">
        <div v-if="selectedProduct && selectedPlan" class="user-summary--section">
            <div class="user-summary--section--content">
                <p class="user-summary--section--title">{{$t('REGISTER_CHECKOUT_SUMMARY_SECTON_FLOWERS')}}</p>
                <div class="user-summary--price--container">
                    <h2 class="user-summary--price--container--product">{{selectedProductDisplayName}}</h2>
                    <h2 class="user-summary--price--container--value" :class="{'strike-out': showDiscount}">{{currency}}{{selectedBoxPrice}}</h2>
                    <h2 class="user-summary--price--container--plan">{{subscriptionSummary}}</h2>
                    <p class="user-summary--price--container--value">{{discountPrice}}</p>
                </div>
                <div class="user-summary--section--coupon" v-if="couponProperties">
                    <img class="user-summary--section--coupon--image" src="@/assets/images/pages/checkout/offer-icon.png" alt="offer applied icon">
                    <p class="user-summary--section--coupon--text">{{couponProperties.successful_message}}<br>{{couponProperties.code}}</p>
                </div>
            </div>
            <div class="user-summary--section--link" v-if="showLink('register.subscription-details')">
                <router-link :to="{ name: 'register.subscription-details'}">{{$t('REGISTER_CHECKOUT_SUMMARY_LINK')}}</router-link>
            </div>
        </div>
        <div v-if="deliveryAddress.addressLine1" class="user-summary--section">
            <div class="user-summary--section--content">
                <p class="user-summary--section--title">{{$t('REGISTER_CHECKOUT_SUMMARY_SECTON_DELIVERY')}}</p>
                <h2 class="user-summary--section--details">{{deliveryAddress.addressLine1}}</h2>
            </div>
            <div class="user-summary--section--link" v-if="showLink('register.delivery-details')">
                <router-link :to="{ name: 'register.delivery-details'}">{{$t('REGISTER_CHECKOUT_SUMMARY_LINK')}}</router-link>
            </div>
        </div>
        <div v-if="showContact" class="user-summary--section">
            <div class="user-summary--section--content">
                <p class="user-summary--section--title">{{$t('REGISTER_CHECKOUT_SUMMARY_SECTON_CONTACT')}}</p>
                <h2 class="user-summary--section--details">{{email}}</h2>
            </div>
            <div class="user-summary--section--link" v-if="showLink('register.your-details')">
                <router-link :to="{ name: 'register.your-details'}">{{$t('REGISTER_CHECKOUT_SUMMARY_LINK')}}</router-link>
            </div>
        </div>
        <total-section class="user-summary--section--total"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PRODUCT_FAMILY_BUMPER, PRODUCT_FAMILY_STANDARD } from '@/constants/Gifting';
import TotalSection from '@/components/forms/fields/TotalSection';

export default {
    name: 'UserCheckoutSummery',
    components: {
        TotalSection,
    },
    computed: {
        ...mapGetters({
            selectedProduct: 'register/getSelectedProductDetails',
            selectedPlan: 'register/getSelectedPlan',
            deliveryAddress: 'register/getDeliveryAddress',
            couponProperties: 'register/getCouponProperties',
            email: 'register/getEmail',
            firstName: 'register/getFirstName',
            currency: 'localisation/getCurrency',
        }),
        subscriptionSummary() {
            // removing product name untill bumper box is added to the new checkout
            // return `${this.selectedPlan?.plan_interval} / ${this.selectedProduct?.plan_name} - `;
            // return `${this.selectedPlan?.plan_interval} / `;
            return `${this.selectedPlan?.plan_interval.charAt(0).toUpperCase() + this.selectedPlan?.plan_interval.slice(1)}`;
        },
        showContact() {
            return this.email && this.firstName && this.$route.name !== 'register.subscription-details';
        },
        selectedProductDisplayName() {
            return `${this.selectedProduct?.display_name}:`;
        },
        selectedBoxPrice() {
            return `${Number(this.selectedProduct?.price || this.boxPrice)} / `;
        },
        discountPrice() {
            let amount = this.couponProperties?.payable_amount;
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_BUMPER) amount = this.couponProperties?.payable_amount_bumper;
            return this.showDiscount ? `${this.currency}${Number(amount)}` : '';
        },
        showDiscount() {
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_BUMPER) return Number(this.couponProperties?.payable_amount_bumper) < this.selectedBoxPrice;
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_STANDARD) return Number(this.couponProperties?.payable_amount) < this.selectedBoxPrice;
            return true;
        },
        boxPrice() {
            if (this.selectedProduct?.product_family.toLowerCase() === PRODUCT_FAMILY_BUMPER) return process.env.VUE_APP_BUMPER_BOX_PRICE;
            return process.env.VUE_APP_BOX_PRICE;
        },
    },
    methods: {
        showLink(name) {
            return this.$route.name !== name;
        },
    },
};
</script>

<style lang="scss" scoped>
.user-summary {
    width: 100%;
    margin-top: 30px;
    position: relative;

    @media screen and (min-width: 640px) {
        background-color: #F7F7F7;
        padding: 40px 20px;
        height: fit-content;
    }

    &--border {
        display: none;
        @media screen and (min-width: 640px) {
            display: block;
            position: absolute;
            top: -30px;
            right: -20px;
        }
    }

    &--section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.15);
        padding: 10px 32px;

        &--content {
            overflow: hidden;
            text-overflow: ellipsis;
            @media (max-width: 640px) {
                max-width: 250px;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &--link {
            & a {
                font-size: 14px;
                line-height: 20px;
                color: #63A75E;
            }
            &:hover {
                cursor: pointer;
            }
        }
        &--title {
            font-size: 14px;
            line-height: 20px;
            color: #262323;
            margin: 0;
        }
        &--details {
            width: 100%;
            font-weight: 400;
            font-size: 16px;
            line-height: 25px;
            color: #262323;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            @media screen and (min-width: 640px) {
                font-size: 18px;
            }
        }
        &--coupon {
            display: flex;
            &--image {
                width: 12px;
                height: 12px;
                margin-right: 10px;
            }
            &--text {
                margin: 0;
                color: #63A75E;
                font-weight: 400;
                font-size: 12px;
                line-height: 15px;
            }
            @media screen and (min-width: 640px) {
                display: none;
            }
        }
        &--total {
            @media screen and (max-width: 640px) {
                display: none;
            }
        }
    }
    &--price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        padding-bottom: 0;
        &--text {
            font-weight: 400;
            margin: 0;
            font-size: 18px;
            line-height: 24px;
        }
        &--value {
            width: 20%;
            font-weight: 400;
            margin: 0 5px;
            font-size: 20px;
            line-height: 24px;
        }
        &--container {
            display: flex;
            &--product, &--plan, &--value {
                // width: 40%;
                font-weight: 400;
                font-size: 16px;
                line-height: 25px;
                color: #262323;
                margin: 0;
                padding-right: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                @media screen and (min-width: 640px) {
                    font-size: 18px;
                }
            }
        }
    }
}
.strike-out {
    text-decoration: line-through;
    opacity: 0.6;
}
</style>
